import Hosts from '../../../../Hosts';

const object_type = 'intranet/components'
 
const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/type/${companycode}/jogos`

const base_endpoint = '/intranet_jogos'
 
const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    info: {
        logo: [],
        active: false,
        available: false,
        companycode: '',
        stage: '',
        type: 'jogos', 
        name: '',
        tipo_competicao: '',
        modalidade: '',
        escaloes: [],
        epoca: '',
        data_inicio: '',
        data_fim: '',
        regulamento: [],
        observacoes: '',
        clubes_inscritos: [],
        atletas_inscritos: [],
        classificacoes: {},
        responsavel: { identificacao: '', telefone: '', email: '' },
    },   
    notifications: []
}

export {
    object_type,
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}
